const PET_HEIGHT_PX = 52;
// Matches the lane column's gap-3.
const GAP_PX = 12;
// Racers run from the start gate to their position once, when the track mounts.
const ENTRY_DURATION_MS = 2000;

export const racetrackLanes = {
  PET_HEIGHT_PX,
  GAP_PX,
  ENTRY_DURATION_MS,
};
